var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_4841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49999 1.41666C4.58291 1.41666 1.41666 4.58291 1.41666 8.5C1.41666 12.4171 4.58291 15.5833 8.49999 15.5833C12.4171 15.5833 15.5833 12.4171 15.5833 8.5C15.5833 4.58291 12.4171 1.41666 8.49999 1.41666ZM8.49999 14.1667C5.37624 14.1667 2.83332 11.6237 2.83332 8.5C2.83332 5.37625 5.37624 2.83333 8.49999 2.83333C11.6237 2.83333 14.1667 5.37625 14.1667 8.5C14.1667 11.6237 11.6237 14.1667 8.49999 14.1667ZM11.0429 4.95833L8.49999 7.50125L5.95707 4.95833L4.95832 5.95708L7.50124 8.5L4.95832 11.0429L5.95707 12.0417L8.49999 9.49875L11.0429 12.0417L12.0417 11.0429L9.49874 8.5L12.0417 5.95708L11.0429 4.95833Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_4841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.9be9544bacef0f110848a4d931b6f96b.svg";
export { ForwardRef as ReactComponent };